import PropTypes from "prop-types"
import { cn } from "../lib/utils"

export const Link = ({
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  children,
  className,
}) => (
  <a
    href={href}
    target={target}
    rel={rel}
    className={cn("text-gray-600 underline hover:font-bold", className)}
  >
    {children}
  </a>
)

export const IconLink = ({
  icon,
  children,
  className,
  onClick,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
}) => {
  const classes = cn(
    "inline-flex items-center gap-1 cursor-pointer text-brand no-underline hover:opacity-80 font-medium",
    className,
  )
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classes}>
        {icon && <i className={icon}></i>}
        {children}
      </button>
    )
  }
  return (
    <a href={href} target={target} rel={rel} className={classes}>
      {icon && <i className={icon}></i>}
      {children}
    </a>
  )
}

Link.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}

IconLink.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
}
